import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FoldersViewController } from '@commoncore/controller/FoldersViewController';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';
import { Subscription } from 'rxjs';


@Component({
  standalone:true,
  selector: 'lib-foldersview',
  templateUrl: './folderview.component.html',
  styleUrls: ['./folderview.component.css'],
  imports:[DependenciesModule]
})
export class FolderviewComponent implements OnInit, OnDestroy {
 allFilesController:any= null;
 homeController:any = null;
 public universalService:any;
 public listService:any;
 public folderService:any;
 public router:any;
 public obs:Subscription;
  controller: any;
  implRef: any;
  shareAccessService:any;
  localStorageSvc:any;
  containerHeightCalc:any;
  dropdownlist: any = [];
  constructor(public globalService:GlobalService) {
    this.setEnvObjects()
    //, public allFilesService:AllFilesService,public shareService:ShareService,public listService:ListService 
  }
  @HostListener('document:click', ['$event'])
  clickHandler(event: MouseEvent) {
    var node = event.target as HTMLElement;
    if(node.classList.length > 0 && !(node.classList.contains("dropdown-content") || node.classList.contains("NeueFolderFilled"))){
      this.closeDropdown();
    }
  }

  setEnvObjects(){
    this.universalService = this.globalService.getUniversalServiceRef();
    this.listService = this.globalService.getListServiceRef();
    this.folderService = this.globalService.getFolderServiceRef();
    this.router = this.globalService.getRouterRef()
    this.shareAccessService = this.globalService.getShareAccessServiceRef();
    this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
    this.containerHeightCalc = this.globalService.getContainerHeightCalculatorService();
  }

  ngOnInit() {
    var self = this;
    if(this.universalService.currentTab == "allfiles"){
      AppEvents.emit(EventsList.EMPTY_TABBED_VIEW)
    }
    this.obs = AppEvents.globalObservable.subscribe(event => {
      if(event["navigate"]){
        self.setEnvObjects();
        self.universalService.openFolderContent = true;
        self.navigateBreadCrumb(event["folderKey"]);
      }else if(event["open"]){
        self.openFolderContent(event["object"]["objectKey"],event["objectName"],event["object"]);
      }
    })
    this.universalService.showTopMenu = false;  
    this.universalService.hideTopMenuOptions();

    if(this.universalService.openFolderContent &&  this.universalService.selectedFile){

      if(this.universalService.selectedFile.objectType=='FR' || this.universalService.selectedFile.objectType=='BR'){
        this.openFolderContent(this.universalService.selectedFile["objectKey"],this.universalService.selectedFile["objectName"],this.universalService.selectedFile)
      } 
    }
  }


  async openFolderContent(folderObjectKey, folderObjectName,folderObject) {
    this.controller=FoldersViewController.getInstance(this.globalService)
    this.implRef = this.controller.foldersViewImplementation;
    this.controller.setEnvObjects(this.globalService);
    this.controller.openFolderContent(folderObjectKey,folderObjectName,folderObject)
  
    setTimeout(()=>{
      let el = (document.querySelector('.allfilesAgGrid #ag-grid')) as any ;
      if((folderObjectKey == '1'  && el)){
          // $('.allfilesAgGrid  #ag-grid').height('auto'); // This is code nor more required to fix outside scrollbar on root
      }else{
        this.setHeightForCurrentView();
      }
    },1000)
  }

  navigateBreadCrumb(folderObjectKey) {
    if(folderObjectKey =="dummyEntry1" || folderObjectKey == "dummyEntry2") {
      folderObjectKey = "1";
    }
    //this.universalService.foldersArray = []
    this.universalService.sortByDateArray = []
    this.universalService.sortByNameArray = []
    this.universalService.showFileInfo = false;
    this.universalService.selectedNodes =[];
    this.universalService.showTopMenu = false;
    this.listService.headerCheckBoxChecked = false;
    this.universalService.emptyTab = false;
    this.universalService.hideTopMenuOptions();
    this.universalService.operationInProgress = false;
    if(this.universalService.mobileSelectionModeOn){
      this.universalService.switchOffMobileSelectionMode();
    }
    if(this.universalService.activeRepo == 'main'){
      if(this.router.url.includes('/sharedbyme')){
        this.navigateBreadCrumbForSharedFiles(folderObjectKey,'sharedbyme')
      }else if(this.router.url.includes('/sharedwithme')){
        this.navigateBreadCrumbForSharedFiles(folderObjectKey,'sharedwithme')
      }else{
        var searchKey = this.localStorageSvc.getSearchKey(LocalStorageProps.SEARCH_KEY);
        if(searchKey != "" && folderObjectKey == "1"){
          if(searchKey["searchType"] == "global"){
            this.router.navigate(['/search'],{ queryParams: { q: searchKey["keyword"]}});
          }else{
            this.router.navigate(['/search', JSON.parse(decodeURIComponent(btoa(searchKey)))["keyword"]]);
          }
        }else{
          // this.router.navigate(['/allfiles', folderObjectKey])
          if(folderObjectKey != "1") {
            if(this.router.url.includes("teamfolders")){
              var getTF = this.folderService.breadCrumbsList.find(brdcmb => brdcmb["objectKey"] == folderObjectKey);
              var tfKey = getTF ? (getTF["tfKey"] ? getTF["tfKey"] : "") : "";
              this.router.navigate(['/teamfolders', folderObjectKey],{ queryParams: { tfKey: tfKey}})
            }else if(this.router.url.includes("privatefolder")){
              this.router.navigate(['/privatefolder', folderObjectKey])
            }else if(this.router.url.includes("jpai")){
              this.router.navigate(['/jpai', folderObjectKey])
            }
            else 
            this.router.navigate(['/allfiles', folderObjectKey])
          }else if(folderObjectKey == "1" && this.universalService.currentTab == "PrivateFolder"){
            this.router.navigate(['/privatefolder'])
          }else if(folderObjectKey == "1" && this.universalService.currentTab == "DigiLocker"){
            this.router.navigate(['digilocker']);
            return;
          } 
        }
      }
    }else if(this.universalService.activeRepo == 'share'){
      if(this.folderService.breadCrumbsList.length>1){
        if(folderObjectKey == 1) this.shareAccessService.currentOpenFolderName = '';
        this.universalService.openFolderContent = true;
      }
    }
    this.universalService.selectedFile =this.folderService.openFolderFromBreadCrumb(folderObjectKey);
    this.openFolderContent(this.folderService.currentFolderKey, this.folderService.currentFolderName, this.folderService.currentFolder);    
  }

  ngOnDestroy(){
      this.allFilesController = null;
      this.homeController = null;
      this.folderService = null;
      this.listService = null;
      this.universalService = null;
      if(this.obs !=undefined) {
        this.obs.unsubscribe();
      }
  }

  navigateBreadCrumbForSharedFiles(folderObjectKey,tabName){
    if(this.folderService.breadCrumbsList.length>1 && this.folderService.breadCrumbsList.length<2){
      this.router.navigate(['/shared',tabName])
    }else{
      this.router.navigate(['/shared',tabName, folderObjectKey])
    }
  }

  setHeightForCurrentView(){ 
    if(this.globalService.getUniversalServiceRef().activeRepo == 'main'){
      this.containerHeightCalc.calculateHeight('.allfilesAgGrid  #ag-grid',['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'],84)
    }else{
      if(!this.globalService.getUniversalServiceRef().isUnivSharelink){
        this.containerHeightCalc.calculateHeight('.tab-content #ag-grid',['.pseudo-header','.pseudo-top-header','.pseudo-adsContainer','.pseudo-banner-container'],84)
      }
    }
  }

  openDropDown(){
    var lst = this.globalService.getFolderServiceRef().breadCrumbsList;
    var newdropdownlist = [];
    this.dropdownlist = lst.slice(1,lst.length - 2);
    this.dropdownlist.map(lst=>{
      if(!lst["objectKey"].includes("dummyEntry")){
        newdropdownlist.push(lst);
      }
    })
    this.dropdownlist = newdropdownlist;
  }

  closeDropdown(){
    this.dropdownlist = [];
  }

  redirdect(obj){
    
  }
}
